import { colors } from '../../../styles/colors';
import { CONSTANTS } from '../../../styles/styleConstants';

export const audioRecorderContainerStyle: React.CSSProperties = {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    // alignItems: 'center',
    paddingTop: 5,
    alignSelf: 'stretch',
    paddingBottom: 25
};

export const newCommentAudioRecorderStyle: React.CSSProperties = {
    height: 56,
    borderRadius: 28,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: CONSTANTS.COLORS.WHITE,
    margin: 20,
    flex: 1
};

export const existingCommentAudioRecorderStyle: React.CSSProperties = {
    display: 'flex',
    flex: 1,
    height: 32,
    borderRadius: 16,
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#727474',
    marginTop: 12
};

export const buttonStyle: React.CSSProperties = {
    padding: 0,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
};

export const startStopButtonStyle: React.CSSProperties = {
    ...buttonStyle,
    borderRadius: 17,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: colors.MEDIUM_GREY
};

export const newCommentButtonContainerStyle: React.CSSProperties = { width: undefined, margin: 12 };

export const existingCommentButtonContainerStyle: React.CSSProperties = { width: undefined, marginRight: 8 };

export const existingCommentStartStopButtonStyle: React.CSSProperties = { objectFit: 'contain' };

export const existingCommentProgressTrackStyle: React.CSSProperties = { backgroundColor: 'rgba(229,229,229,0.14)', height: 2, borderRadius: 1 };
export const newCommentProgressTrackStyle: React.CSSProperties = { backgroundColor: colors.MEDIUM_GREY, height: 2, borderRadius: 1 };

export const progressHandleHiddenStyle: React.CSSProperties = { display: 'none' };

export const newCommentProgressHandleStyle: React.CSSProperties = {
    height: 12,
    width: 12,
    borderRadius: 6,
    backgroundColor: colors.ACTION_GREEN,
    borderWidth: 0,
    marginTop: -1
};

export const newCommentProgressBarStyle: React.CSSProperties = {
    height: 3,
    borderRadius: 1.5
};

export const newCommentProgressLabelStyle: React.CSSProperties = { color: colors.ACTION_GREEN, fontSize: 15, marginLeft: 9 };
export const existingCommentProgressLabelStyle: React.CSSProperties = { color: colors.WHITE, fontSize: 12, marginLeft: 9, fontWeight: 600, marginRight: 13 };

export const newCommentProgressBackgroundStyle: React.CSSProperties = {
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
};

export const manageButtonContainerStyle: React.CSSProperties = { display: 'flex', flexDirection: 'row' };

export const newCommentManageButtonContainerStyle: React.CSSProperties = { ...manageButtonContainerStyle, marginRight: 12 };

const manageButtonStyle: React.CSSProperties = {
    width: 60,
    height: 34,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
};

export const clearButtonStyle: React.CSSProperties = {
    ...manageButtonStyle,
    borderTopLeftRadius: 17,
    borderBottomLeftRadius: 17,
    backgroundColor: colors.CANCEL_TEXT,
    cursor: 'pointer'
};

export const confirmButtonStyle: React.CSSProperties = {
    ...manageButtonStyle,
    borderTopRightRadius: 17,
    borderBottomRightRadius: 17,
    backgroundColor: colors.ACTION_GREEN,
    cursor: 'pointer'
};

export const manageButtonLabelStyle: React.CSSProperties = { fontSize: 13, fontWeight: 'bold', color: CONSTANTS.COLORS.WHITE };

export const placeholderTextStyle: React.CSSProperties = { color: '#BDBDBD', fontSize: 16 };

export function getRoundAudioButtonStyle(size: number): React.CSSProperties {
    return { height: size, width: size, borderRadius: size / 2 };
}



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/Audio/AudioStyles.ts